import React, { Component } from 'react';
import { CardElement, injectStripe } from 'react-stripe-elements/dist/react-stripe-elements';
import './CheckoutForm.css'
import InputWithClearButton from '../InputWithClearButton';

class CheckoutForm3DAuthorization extends Component {

    constructor(props) {
        super(props);
        this.state = {
            complete: false,
            orderId: props.orderId,
            name: '',
            email: '',
            cardNumber: '',
            paymentIntent: this.props.paymentIntent
        };
        this.submit = this.submit.bind(this);
    }

    submit = async (event) => {
        event.preventDefault();

        this.props.stripe.confirmCardPayment(this.state.paymentIntent, {
            payment_method: {
                card: this.props.elements.getElement('card'),
                billing_details: {
                    name: 'Jenny Rosen',
                },
            }
        }).then(async (res) => {
            console.log(res);
           // if (res.status == 'succeded') {
                //let { token } = await this.props.stripe.createToken({ name: this.state.name });
                //let response = await fetch("/api/Pay/Submit", {
                //    headers: {
                //        'Accept': 'application/json',
                //        'Content-Type': 'application/json'
                //    },
                //    method: "POST",
                //    //headers: { "Content-Type": "text/plain" },
                //    body: JSON.stringify({ token: token.id, orderId: this.state.orderId, name: this.state.name, email: this.state.email })
                //});

                //response.json().then(res => {
                //    if (res.success) {
                //        window.open(res.receiptUrl, "_blank");
                //        this.setState({ complete: true });

                //        // <div className="success">
                //        {/*<h2>Payment Successful!</h2>
                //    <a href={res.receiptUrl}>View Receipt</a>
                //    <Link to="/">Home</Link>
                //</div >*/}
                //    }
                //})
                //    .catch(err => {
                //        console.log(err);
                //    });
          //  }
        });

        return;

        let { token } = await this.props.stripe.createToken({ name: this.state.name });
        let response = await fetch("/api/Pay/Submit", {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: "POST",
            //headers: { "Content-Type": "text/plain" },
            body: JSON.stringify({ token: token.id, orderId: this.state.orderId, name: this.state.name, email: this.state.email })
        });

        response.json().then(res => {
            if (res.success) {
                window.open(res.receiptUrl, "_blank");
                this.setState({ complete: true });

                // <div className="success">
                {/*<h2>Payment Successful!</h2>
                    <a href={res.receiptUrl}>View Receipt</a>
                    <Link to="/">Home</Link>
                </div >*/}
            }
        })
            .catch(err => {
                console.log(err);
            });

        //if (response.ok) this.setState({ complete: true });
    }

    render = () => {
        if (this.state.complete) return <h1>Purchase Complete</h1>;

        return (
            <div className="Checkout">
                <form onSubmit={this.submit}>
                    <InputWithClearButton
                        className='StripeElement'
                        type='text'
                        placeholder='Please enter name as stated on card'
                        value={this.state.name}
                        onChange={e => {
                            this.setState({ name: e.target.value });
                        }}
                        onClearValue={() => {
                            this.setState({ name: '' });
                        }}
                    />
                    <CardElement />
                    <button className="payButton">Pay</button>
                </form>
            </div>
        );
    }
}

export default injectStripe(CheckoutForm3DAuthorization);


{/*
            <div className="checkout">
                <p>Would you like to complete the purchase?</p>


                <CardElement />
                <button className='medium-static-button static-button default-button' onClick={this.submit}>Purchase</button>
            </div>
            */}


// WEBPACK FOOTER //
// ./src/components/Payment/CheckoutForm3DAuthorization.jsx